export const ROUTES = {
  HOME: '/home',
  CATALOG: '/catalog',
  PRODUCT: '/product/:id',
  SEARCH: '/search',
  COMING_SOON: '/coming-soon'
} as const;

export type AppRoutes = typeof ROUTES[keyof typeof ROUTES]; 